export const SET_TERMS = 'eContracts/SET_TERMS'
export const E_SET_TERMINATION_XML = 'eContracts/SET_TERMINATION_XML'
export const SET_TERMINATION_LOADING = 'eContracts/SET_TERMINATION_LOADING'
export const SET_TERMINATION_SUCCESS = 'eContracts/SET_TERMINATION_SUCCESS'
